<template>
    <div class="rain-tip-dropdown" v-bind:class="{ 'dropdown-open': rainDropdownTip === true }">
        <button v-on:click="rainSetDropdownTip(!rainDropdownTip)" class="button-toggle" type="button" :aria-expanded="rainDropdownTip" aria-label="Tip Rain balance and options">
            <span class="toggle-left">
                <span class="toggle-icon"><IconRain /></span>
                <span class="toggle-label">Tip Rain</span>
            </span>
            <span class="toggle-amount">
                <IconCoin />
                <span class="amount-value">
                    <template v-if="generalRain && generalRain.site && generalRain.site.amount">{{ rainFormatValue(generalRain.site.amount) }}</template>
                    <template v-else>0.00</template>
                </span>
            </span>
            <span class="toggle-chevron" aria-hidden="true">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
        </button>
        <div class="dropdown-window">
            <div class="window-inner">
                <div class="inner-timer">
                    <IconTimer />
                    <div class="timer-value">
                        <span>{{rainTimer.split(':')[0]}}</span>m
                        <span>{{rainTimer.split(':')[1]}}</span>s
                    </div>
                </div>
                <div class="inner-info">
                    Half of the rain pot is split evenly amongst players while the other half is split amongst levels.
                </div>
                <div class="inner-input">
                    <input v-model="rainAmount" v-on:input="rainValidateInput" type="text" placeholder="TIP AMOUNT" />
                    <button v-on:click="rainTipButton" class="button-tip">
                        <div class="button-inner">TIP</div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import IconRain from '@/components/icons/IconRain';
    import IconTimer from '@/components/icons/IconTimer';
    import IconCoin from '@/components/icons/IconCoin';

    export default {
        name: 'RainTipDropdown',
        components: {
            IconRain,
            IconTimer,
            IconCoin
        },
        data() {
            return {
                rainTimerInterval: null,
                rainTimer: '00:00',
                rainAmount: ''
            }
        },
        methods: {
            ...mapActions(['notificationShow', 'rainSetDropdownTip', 'generalSendRainTipSocket']),
            rainFormatValue(value) {
                return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
            rainValidateInput() {
                this.rainAmount = this.rainAmount.replace(/[^\d.]/g, '');
            },
            rainStartTimer() {
               if (!this.generalRain || !this.generalRain.site || !this.generalRain.site.updatedAt) {
                   this.rainTimer = '00:00';
                   return;
               }
               
               const endingTime = new Date(this.generalRain.site.updatedAt).getTime() + (1000 * 60 * (this.generalRain.site.state === 'running' ? 2 : 30));
               let timeLeft = Math.floor((endingTime - (new Date().getTime() + (this.generalTimeDiff || 0))) / 1000);
               timeLeft = this.generalRain.site.state === 'pending' ? 60 * 2 : timeLeft <= 0 ? 0 : timeLeft;

               let timeMinutes = Math.floor((timeLeft % (60 * 60)) / 60);
               timeMinutes = timeMinutes < 10 ? '0' + timeMinutes : timeMinutes;
               let timeSeconds = Math.floor(timeLeft % 60);
               timeSeconds = timeSeconds < 10 ? '0' + timeSeconds : timeSeconds;

               this.rainTimer = timeMinutes.toString() + ':' + timeSeconds.toString();
           },
           rainTipButton() {
                if(this.socketSendLoading !== null) { return; }

                const amount = parseFloat(this.rainAmount);

                if(amount === undefined || isNaN(amount) === true || amount < 1) {
                    this.notificationShow({ type: 'error', message: 'Your entered rain tip amount is invalid. Minimum tip is $1 USD.' });
                    return;
                }

                const data = { amount: amount };
                this.generalSendRainTipSocket(data);

                this.rainAmount = null;
                this.rainSetDropdownTip(false);
           }
        },
        computed: {
            ...mapGetters(['socketSendLoading', 'authUser', 'generalTimeDiff', 'rainDropdownTip', 'generalRain']),
        },
        created() {
            let self = this;
            document.addEventListener('click', function(event) {
                if(!self.$el.contains(event.target) && event.path !== undefined && event.path.some((element) => element._prevClass === 'button-tip') === false && self.rainDropdownTip === true) {
                    self.rainSetDropdownTip(false);
                }
            });

            this.rainTimerInterval = setInterval(() => { this.rainStartTimer(); }, 500);
        }
    }
</script>

<style scoped>
    .rain-tip-dropdown {
        width: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        margin-top: 14px;
        z-index: 10;
    }

    .rain-tip-dropdown button.button-toggle {
        width: 100%;
        height: 48px;
        position: relative;
        padding: 0 14px 0 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 12px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        cursor: pointer;
        transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
        z-index: 2;
    }

    .rain-tip-dropdown button.button-toggle:hover {
        background: rgba(255, 255, 255, 0.08);
        border-color: rgba(255, 255, 255, 0.15);
    }

    .rain-tip-dropdown.dropdown-open button.button-toggle {
        border-color: rgba(0, 255, 194, 0.3);
        box-shadow: 0 0 0 1px rgba(0, 255, 194, 0.1);
    }

    .rain-tip-dropdown .toggle-left {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .rain-tip-dropdown .toggle-icon {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .rain-tip-dropdown .toggle-icon svg {
        width: 22px;
        height: 22px;
    }

    .rain-tip-dropdown .toggle-label {
        font-size: 13px;
        font-weight: 700;
        color: rgba(255, 255, 255, 0.9);
        letter-spacing: 0.3px;
    }

    .rain-tip-dropdown .toggle-amount {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .rain-tip-dropdown .toggle-amount img {
        width: 14px;
        height: 14px;
        object-fit: contain;
    }

    .rain-tip-dropdown .toggle-amount .amount-value {
        font-size: 14px;
        font-weight: 800;
        color: var(--accent-yellow, #facc15);
        letter-spacing: 0.5px;
    }

    .rain-tip-dropdown .toggle-chevron {
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(255, 255, 255, 0.5);
        transition: transform 0.25s ease, color 0.2s ease;
    }

    .rain-tip-dropdown.dropdown-open .toggle-chevron {
        transform: rotate(180deg);
        color: var(--accent-yellow, #facc15);
    }

    .rain-tip-dropdown .toggle-chevron svg {
        width: 12px;
        height: 12px;
    }

    .rain-tip-dropdown .dropdown-window {
        height: 0;
        position: absolute;
        top: 54px;
        left: 0;
        right: 0;
        padding: 0;
        transition: height 0.25s ease;
        overflow: hidden;
        z-index: 1;
    }

    .rain-tip-dropdown.dropdown-open .dropdown-window {
        height: 172px;
        padding: 10px 0 0 0;
    }

    .rain-tip-dropdown .window-inner {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 14px 16px 14px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 14px;
        background: rgba(30, 34, 56, 0.98);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
    }

    .rain-tip-dropdown .inner-timer {
        display: flex;
        align-items: center;
    }

    .rain-tip-dropdown .inner-timer svg {
        margin-right: 8px;
        fill: #ffffff;
    }

    .rain-tip-dropdown .timer-value {
        font-size: 10px;
        font-weight: 600;
        color: #bbbfd0;
    }

    .rain-tip-dropdown .timer-value span {
        font-size: 12px;
        font-weight: 800;
        color: #ffffff;
    }

    .rain-tip-dropdown .inner-info {
        width: 100%;
        margin-top: 6px;
        text-align: center;
        font-size: 11px;
        font-weight: 600;
        color: #bbbfd0;
    }

    .rain-tip-dropdown .inner-input {
        width: 250px;
        height: 40px;
        position: relative;
        margin-top: 15px;
        padding: 1px;
        filter: drop-shadow(0px 4px 25px rgba(15, 41, 63, 0.35));
    }

    .rain-tip-dropdown .inner-input::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
       /* background: linear-gradient(180deg, #04131f 0%, #223a4e 100%); */
        clip-path: polygon(8px 0, calc(100% - 8px) 0, 100% 25%, 100% 75%, calc(100% - 8px) 100%, 8px 100%, 0 75%, 0 25%);
    }

    .rain-tip-dropdown .inner-input input {
        width: 100%;
        height: 100%;
        padding: 0 80px 0 15px;
        font-size: 10px;
        font-weight: 600;
        color: #ffffff;
        border-radius: 15px;
        background-color: var(--bg-blue-chat);
        clip-path: polygon(8px 0, calc(100% - 8px) 0, 100% 25%, 100% 75%, calc(100% - 8px) 100%, 8px 100%, 0 75%, 0 25%);
    }

    .rain-tip-dropdown .inner-input input::placeholder {
        color: #5e768e;
    }

    .rain-tip-dropdown button.button-tip {
        width: 50px;
        height: 22px;
        position: absolute;
        top: 50%;
        right: 18px;
        transform: translate(0, -50%);
        filter: drop-shadow(0px 2px 10px rgba(1, 230, 169, 0.15)) drop-shadow(0px 4px 25px rgba(15, 41, 63, 0.35));
    }

    .rain-tip-dropdown button.button-tip .button-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-weight: 800;
        color: #ffffff;
        border-radius: 8px;
        background: var(--accent-btn-purple);
        clip-path: polygon(4px 0, calc(100% - 4px) 0, 100% 25%, 100% 75%, calc(100% - 4px) 100%, 4px 100%, 0 75%, 0 25%);
    }
</style>
